/* ============================================================
   BERUNDA — Testimonials · drifting calling-card marquee
   ────────────────────────────────────────────────────────────
   Theme build: the notes come from the section's schema blocks
   (Shopify admin → Berunda home → Testimonials), serialised into
   #bf-testimonials. Everything else — cloning, looping, arrows,
   stagger, the flip — is the design kit's own behaviour.
   ============================================================ */
(function () {
  "use strict";

  var data = document.getElementById("bf-testimonials");
  var TESTIMONIALS = [];
  if (data) { try { TESTIMONIALS = JSON.parse(data.textContent) || []; } catch (e) { TESTIMONIALS = []; } }
  if (!TESTIMONIALS.length) return;

  var EMBLEM = data.getAttribute("data-emblem") || "";

  /* Owners type these in the admin, so never trust them as markup. */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  var band = document.querySelector("[data-praise-band]");
  var track = document.getElementById("bf-praise-track");
  if (!band || !track) return;

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var setW = 0, pos = 0, speed = 0, BASE = 26; /* px per second */
  var hover = false, dragging = false, visible = true, tween = null, rafId = null;
  var inkIO = null;

  function attrHtml(t) {
    return '<figcaption class="bf-praise-attr">' +
      '<span class="bf-praise-name">' + esc(t.name) + '</span>' +
      '</figcaption>';
  }

  function cardHtml(t, i) {
    var words = t.quote.split(" ").map(function (w, j) {
      return '<span style="--w:' + j + '">' + esc(w) + '</span>';
    }).join(" ");
    return '<div class="bf-praise-slot"><figure class="bf-praise-card" style="--i:' + i + '">' +
      '<div class="pc-inner">' +
        '<div class="pc-face pc-front">' +
          '<div class="bf-praise-frame" aria-hidden="true"></div>' +
          (t.city ? '<span class="bf-praise-stamp" aria-hidden="true"><i></i><b>' + esc(t.city) + '</b><i></i></span>' : '') +
          '<div class="pc-body"><span class="bf-praise-glyph" aria-hidden="true">\u201D</span>' +
          '<blockquote class="bf-praise-quote">' + words + '</blockquote>' +
          '<button class="pc-more" type="button" data-more>Read more</button></div>' +
          attrHtml(t) +
          '<img loading="lazy" class="bf-praise-crest" src="' + EMBLEM + '" alt="" aria-hidden="true" />' +
        '</div>' +
        '<div class="pc-face pc-back" aria-hidden="true">' +
          '<div class="bf-praise-frame" aria-hidden="true"></div>' +
          '<img loading="lazy" class="bf-praise-crest" src="' + EMBLEM + '" alt="" aria-hidden="true" />' +
          '<div class="pc-back-body"><blockquote class="pc-full">' + esc(t.quote) + '</blockquote></div>' +
          '<div class="pc-back-foot"><span class="pc-rule" aria-hidden="true"></span>' + attrHtml(t) +
          '<button class="pc-close" type="button" data-close>Close</button></div>' +
        '</div>' +
      '</div></figure></div>';
  }

  function buildSet(hidden) {
    var el = document.createElement("div");
    el.className = "bf-praise-set";
    el.innerHTML = TESTIMONIALS.map(cardHtml).join("");
    if (hidden) {
      el.setAttribute("aria-hidden", "true");
      el.querySelectorAll("button").forEach(function (b) { b.tabIndex = -1; });
    }
    return el;
  }

  function build() {
    track.innerHTML = "";
    track.appendChild(buildSet(false));
    if (!reduced) {
      setW = track.firstChild.getBoundingClientRect().width;
      if (setW) {
        var copies = Math.max(2, Math.ceil((window.innerWidth + setW) / setW));
        for (var i = 0; i < copies; i++) track.appendChild(buildSet(true));
      }
    } else { band.classList.add("static"); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measure); } else { measure(); }
    measure();
    /* Ink reveal: each card writes itself in the first time it enters view */
    if (inkIO) inkIO.disconnect();
    if ("IntersectionObserver" in window) {
      inkIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("inked"); inkIO.unobserve(e.target); }
        });
      }, { threshold: 0.5 });
      track.querySelectorAll(".bf-praise-card").forEach(function (c) { inkIO.observe(c); });
    } else {
      track.querySelectorAll(".bf-praise-card").forEach(function (c) { c.classList.add("inked"); });
    }
  }

  /* ---- Size every card to the tallest front; remember each reverse's height ---- */
  var baseH = 0, MAXH = 640, FRONT_MAX = 620;
  function measure() {
    var cards = Array.prototype.slice.call(track.querySelectorAll(".bf-praise-card"));
    if (!cards.length) return;
    if (openC) closeCard();
    track.classList.add("no-anim");
    cards.forEach(function (c) {
      c.style.height = "";
      c.classList.remove("has-more");
      var q = c.querySelector(".bf-praise-quote");
      if (q) q.style.webkitLineClamp = "";
      c.classList.add("m-front");
    });
    /* Natural front height of every note, unclamped */
    cards.forEach(function (c) { c._frontH = c.offsetHeight; });
    /* The band is as tall as the tallest note that fits inside the cap;
       only notes taller than that get "Read more". */
    var CAP = Math.min(FRONT_MAX, Math.round(window.innerHeight * 0.78));
    baseH = 0;
    cards.forEach(function (c) { if (c._frontH <= CAP) baseH = Math.max(baseH, c._frontH); });
    if (!baseH) baseH = CAP;
    cards.forEach(function (c) { c._more = c._frontH > baseH + 2; });
    /* Clamp each over-long note to the lines that actually fit, allowing
       for the Read more button the class adds. */
    cards.forEach(function (c) { if (c._more) c.classList.add("has-more"); });
    cards.forEach(function (c) {
      if (!c._more) return;
      var q = c.querySelector(".bf-praise-quote");
      if (!q) return;
      var lh = parseFloat(getComputedStyle(q).lineHeight) || 30;
      var over = c.offsetHeight - baseH;
      c._lines = Math.max(3, Math.floor((q.offsetHeight - over) / lh));
    });
    cards.forEach(function (c) {
      if (c._more && c._lines) c.querySelector(".bf-praise-quote").style.webkitLineClamp = c._lines;
      c.classList.remove("m-front");
      c.classList.add("m-back");
    });
    cards.forEach(function (c) { c._backH = c.offsetHeight; });
    cards.forEach(function (c) {
      c.classList.remove("m-back");
      c.style.height = baseH + "px";
    });
    requestAnimationFrame(function () { track.classList.remove("no-anim"); });
  }

  /* ---- Flip: the reverse carries the note in full, card grows to fit ---- */
  var openC = null, locked = false;
  function openCard(c) {
    if (openC === c) return;
    if (openC) closeCard();
    var want = Math.max(baseH, c._backH || baseH);
    c.classList.toggle("is-tall", want > MAXH);
    c.style.height = Math.min(want, MAXH) + "px";
    c.classList.add("is-open");
    c.querySelector(".pc-front").setAttribute("aria-hidden", "true");
    c.querySelector(".pc-back").removeAttribute("aria-hidden");
    openC = c; locked = true;
  }
  function closeCard() {
    var c = openC; if (!c) return;
    openC = null; locked = false;
    c.classList.remove("is-open", "is-tall");
    c.style.height = baseH + "px";
    c.querySelector(".pc-front").removeAttribute("aria-hidden");
    c.querySelector(".pc-back").setAttribute("aria-hidden", "true");
  }

  /* Bound on the band, not the track: a click landing on the band itself
     (padding, or after a pointer-capture retarget) still resolves to the
     card under the cursor. */
  band.addEventListener("click", function (e) {
    if (movedFar) return;
    var c = e.target.closest ? e.target.closest(".bf-praise-card") : null;
    if (!c) {
      var under = document.elementFromPoint(e.clientX, e.clientY);
      c = under && under.closest ? under.closest(".bf-praise-card") : null;
    }
    if (!c) return;
    if ((e.target.closest && e.target.closest("[data-close]")) || c.classList.contains("is-open")) { closeCard(); return; }
    if (c.classList.contains("has-more")) openCard(c);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && openC) closeCard(); });
  document.addEventListener("pointerdown", function (e) {
    if (openC && !(e.target.closest && e.target.closest(".bf-praise-card"))) closeCard();
  });

  function step() {
    var w = track.querySelector(".bf-praise-card");
    if (!w) return 300;
    var r = w.getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track.querySelector(".bf-praise-set")).gap) || 24;
    return r + gap;
  }

  /* ---- Drift loop: speed eases toward its target, position wraps ---- */
  var last = null;
  function frame(now) {
    rafId = requestAnimationFrame(frame);
    if (last == null) { last = now; return; }
    var dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    var target = (hover || dragging || tween || locked || !visible) ? 0 : BASE;
    speed += (target - speed) * Math.min(1, dt * 3.2);
    pos += speed * dt;
    if (tween) {
      var k = Math.min(1, (now - tween.t0) / tween.dur);
      var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      pos = tween.from + tween.delta * e;
      if (k >= 1) tween = null;
    }
    if (setW > 0) { pos = ((pos % setW) + setW) % setW; }
    track.style.transform = "translate3d(" + (-pos) + "px,0,0)";
  }

  function nudge(dir) {
    if (openC) closeCard();
    if (reduced) { band.scrollBy({ left: dir * step(), behavior: "smooth" }); return; }
    tween = { from: pos, delta: dir * step(), t0: performance.now(), dur: 650 };
  }

  /* ---- Pause on hover / focus; drag to browse ---- */
  band.addEventListener("pointerenter", function () { hover = true; });
  band.addEventListener("pointerleave", function () { hover = false; });
  band.addEventListener("focusin", function () { hover = true; });
  band.addEventListener("focusout", function () { hover = false; });

  var dragX = 0, resumeT = null, downX = 0, downY = 0, movedFar = false, capId = null;
  band.addEventListener("pointerdown", function (e) {
    downX = e.clientX; downY = e.clientY; movedFar = false;
    if (reduced) return;
    dragging = true; dragX = e.clientX;
    if (resumeT) clearTimeout(resumeT);
  });
  band.addEventListener("pointermove", function (e) {
    if (Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY) > 8) movedFar = true;
    if (!dragging) return;
    /* Capture only once a real drag begins — capturing on pointerdown makes
       Chrome retarget the click to the band, so buttons never receive it. */
    if (movedFar && capId === null) {
      capId = e.pointerId;
      band.classList.add("dragging");
      try { band.setPointerCapture(capId); } catch (err) {}
    }
    pos -= e.clientX - dragX; dragX = e.clientX;
  });
  function endDrag() {
    if (capId !== null) {
      try { band.releasePointerCapture(capId); } catch (err) {}
      capId = null;
    }
    if (!dragging) return;
    band.classList.remove("dragging");
    resumeT = setTimeout(function () { dragging = false; }, 1600);
  }
  band.addEventListener("pointerup", endDrag);
  band.addEventListener("pointercancel", endDrag);

  /* Sideways scrolling — trackpad / horizontal wheel (and shift+wheel) drives the
     band. No drag-lock: the pointer is already over the band so hover pauses the
     drift, and drift resumes the instant the cursor leaves — nothing keeps moving
     the card after you let go. */
  band.addEventListener("wheel", function (e) {
    if (reduced) return; /* static band scrolls natively */
    var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
    if (!d) return;
    e.preventDefault();
    pos += d;
  }, { passive: false });

  document.querySelectorAll(".bf-praise-arrow").forEach(function (btn) {
    btn.addEventListener("click", function () { nudge(Number(btn.getAttribute("data-dir"))); });
  });

  /* ---- Ink reveal fires per-card on entering view; only drift while on screen ---- */
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible = e.isIntersecting; });
    }, { threshold: 0.15 }).observe(band);
  }

  /* Drift is locked at "Unhurried" (BASE px/s). */

  var rsz = null;
  window.addEventListener("resize", function () {
    if (reduced) return;
    if (rsz) clearTimeout(rsz);
    rsz = setTimeout(function () { build(); }, 200);
  });

  function start() {
    build();
    if (!reduced) rafId = requestAnimationFrame(frame);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else { start(); }
})();
